<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'lg'"
    :centered="true"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div>
      <div class="row">
        <div
          v-for="(item, index) in data_comprobante_pago"
          :key="index"
          :class="[
            'col',
            colClass,
            'd-flex',
            'font-bold',
            item.selected ? 'bg-info' : 'bg-gris',
            'container-type',
          ]"
          @click="selectItem(item.value)"
        >
          <div class="text text-center">{{ item.label }}</div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <CRow>
        <CCol sm="12" lg="6">
          <CInput
            :label="isFactura ? 'RUC' : 'Dni Cliente'"
            :placeholder="isFactura ? 'Digite RUC' : 'Digite DNI'"
            :maxlength="isFactura ? 11 : 8"
            v-model="sale.entity_document"
            @keyup="mtdSearchDocument"
          />
          <div v-if="isFactura && !isRUCValid" class="text-danger">
            El RUC debe contener solo números y hasta 11 dígitos.
          </div>
        </CCol>
        <CCol sm="12" lg="6">
          <CInput
            :label="isFactura ? 'Razón social' : 'Nombre Cliente'"
            :placeholder="isFactura ? 'Digite razón social' : 'nombre'"
            v-model="sale.entity_name"
            disabled
          />
        </CCol>
      </CRow>
      <div class="row">
        <div class="col-lg-6 col-12">
          <h6>MÉTODO DE PAGO</h6>
          <table>
            <tbody v-if="data_metodo_pago.length == 0">
              <tr>
                <td>Sin Metodos de Pago (Agregue en Mantenimiento)</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in data_metodo_pago" :key="index">
                <td v-if="item.label != 'MIXTO'">{{ item.label }}</td>
                <td v-if="item.label != 'MIXTO'">
                  <input
                    type="number"
                    class="form-control"
                    placeholder="0"
                    v-model="item.amount"
                    @input="updateSelectedPayments(item)"
                    min="0"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-lg-6 col-12">
          <div class="row">
            <div class="col-lg-6 col-12">
              <div class="mb-3">
                <CInput label="TOT. VENTA" :value="sale.total" readonly />
              </div>
            </div>
            <div class="col-lg-6 col-12">
              <div class="mb-3">
                <CInput label="TOT. PAGAR" :value="pagoTotal" readonly />
              </div>
            </div>
          </div>

          <div class="mb-3">
            <CInput label="PAGO DEL CLIENTE" :value="pagoCliente" readonly />
          </div>
          <div class="mb-3">
            <CInput label="PENDIENTE" :value="pendiente" readonly />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <button @click="mtdClose" class="btn btn-sm">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button
        @click="mtd_action"
        :disabled="cpButton"
        class="btn btn-info btn-sm"
      >
        Guardado
      </button>
      &nbsp;
    </template>
  </CModal>
</template>
<script>
import { mapActions } from "vuex";
import { bus } from "../../../main";
import CModal from "../../shared/modals/cModalFormCom.vue";

export default {
  name: "c-payment-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "bookings",
      data_comprobante_pago: [],
      data_metodo_pago: [],
      selectedPayments: [],
      sale: {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.value,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        sportsman_id: "",
        date: "",
        method: "",
        type: "",
        total: "",
        amount: "",
        pending: "",
        ruc: "",
        state: 0,
        existingSportman: true,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        booking_id: "",
        sale_id: "",
        new_pending: "",
      },
      isRUCValid: true, // Variable para el estado de validación
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    id: Number,
    total_pay: String,
    id_sale: Number,
    item: Object,
  },
  watch: {
    total_pay(newVal) {
      this.sale.total = newVal;
      this.sale.amount = newVal;
    },
    id(newVal) {
      this.sale.booking_id = newVal;
    },
    id_sale(newVal) {
      this.sale.sale_id = newVal;
    },
    "sale.sale_id"(newWal) {
      if (newWal) {
        this.showSale(newWal);
        this.sale.id = newWal;
      }
    },
  },
  computed: {
    cpButton() {
      return (
        !this.sale.entity_document ||
        !this.sale.entity_name ||
        !this.sale.document_type_id ||
        !this.selectedPayments.length
      );
    },
    isFactura() {
      return this.sale.document_type_id == 2; // Asume que el ID de Factura es 2
    },
    colClass() {
      const itemsCount = this.data_comprobante_pago.length;
      if (itemsCount === 1) return "col-12";
      if (itemsCount === 2) return "col-6";
      if (itemsCount === 3 || itemsCount == 6) return "col-4";
      return "col-6";
    },
    // Suma de los pagos seleccionados
    pagoCliente() {
      if (this.sale.sale_id) {
        const totalAmount = parseFloat(this.sale.amount);
        const totalPayments = this.selectedPayments.reduce(
          (sum, payment) => sum + parseFloat(payment.amount),
          0
        );
        // Suma los valores y luego aplica toFixed(2) al resultado final
        return (totalAmount + totalPayments).toFixed(2);
      } else {
        return this.selectedPayments
          .reduce((sum, payment) => sum + parseFloat(payment.amount), 0)
          .toFixed(2);
      }
    },
    // Calcular el monto pendiente a pagar
    pendiente() {
      if (this.sale.sale_id) {
        // let pendiente = (this.sale.pending - this.)
        let pendiente = (this.sale.total - this.pagoCliente).toFixed(2);
        this.sale.new_pending = pendiente;
        return pendiente;
      } else {
        let pendiente = (this.sale.amount - this.pagoCliente).toFixed(2);
        // let pendiente = (this.total_pay - this.pagoCliente).toFixed(2);
        this.sale.pending = pendiente;
        return pendiente;
      }
    },
    //PAGO TOTAL
    pagoTotal() {
      if (this.sale.sale_id) {
        return this.sale.pending;
      } else {
        return this.sale.amount;
      }
    },
  },
  created() {
    this.showDocumentType();
    this.showMethodPayment();
    this.showBead();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.resetFormData();
      this.showBead();
      this.$emit("closeModalPaymentBooking");
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.value,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let bead = response.data;
          this.sale.bead_id = bead.id;
        })
        .catch((errors) => {});
    },
    showDocumentType() {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/byDocumentType",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_comprobante_pago.push({
              label: name,
              value: id,
              selected: false,
            });
          });
        })
        .catch((errors) => {});
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_metodo_pago.push({
              label: name,
              value: id,
              amount: "",
            });
          });
        })
        .catch((errors) => {});
    },
    selectItem(index) {
      this.sale.document_type_id = index;
      this.data_comprobante_pago.forEach((item, idx) => {
        item.selected = idx === index - 1;
      });

      // Resetear los valores según el tipo de comprobante seleccionado
      if (this.isFactura) {
        this.isRUCValid = true; // Reinicia la validación del RUC
      }
      // this.sale.entity_document = "";
      // this.sale.entity_name = "";
    },
    filtrarSportMan: function () {
      if (!this.validateDNI(this.sale.entity_document)) {
        Swal.fire({
          title: "DNI inválido",
          text: "El DNI debe tener exactamente 8 dígitos y no debe contener letras.",
          icon: "warning",
        });
        return;
      }
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/sportman/" +
          this.sale.entity_document,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "No se encontró DNI",
              icon: "warning",
            });
            this.entity_name = "";
            this.sale.sportsman_id = "";
            this.sale.existingSportman = false;
          } else {
            response.data.data.forEach((element) => {
              this.sale.entity_name = element.name;
              this.sale.sportsman_id = element.id;
            });
          }
        })
        .catch((errors) => {});
    },
    updateSelectedPayments(item) {
      if (item.amount < 0) {
        item.amount = 0;
        return;
      }
      // Elimina cualquier elemento existente con el mismo ID
      if (item.amount === "" || parseFloat(item.amount) === 0) {
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );
        return;
      }
      let newTotal;
      if (item.amount) {
        // Elimina cualquier elemento existente con el mismo ID
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );

        newTotal =
          this.selectedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount),
            0
          ) + parseFloat(item.amount);
      }
      // Verifica que la suma de selectedPayments no exceda el sale.total
      if (this.sale.sale_id) {
        if (newTotal <= this.sale.pending) {
          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        } else {
          Swal.fire({
            title: "La suma de los pagos no puede exceder el total de la venta",
            icon: "warning",
          });
          // item.amount = this.sale.amount - this.pagoCliente; // Limita el valor máximo al restante
          item.amount = parseInt(this.pendiente);
          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        }
      } else {
        if (newTotal <= this.sale.amount) {
          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        } else {
          Swal.fire({
            title: "La suma de los pagos no puede exceder el total de la venta",
            icon: "warning",
          });
          item.amount = this.sale.amount - this.pagoCliente; // Limita el valor máximo al restante

          if (item.amount > 0) {
            this.selectedPayments.push({
              id: item.value,
              label: item.label,
              amount: item.amount,
            });
          }
        }
      }
    },
    mtd_action: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/storeSale",
        token: this.$store.getters.get__token,
        params: {
          sale: this.sale,
          charge: this.selectedPayments,
        },
      })
        .then((response) => {
          let color = "";
          let message = "";
          if (response.statusCode == 200) {
            color = "success";
            message = "REGISTRADO CORRECTAMENTE";
            if (response.data.document_type_id == 3) {
              this.openTicket(response.data.voucher_id);
            } else {
              let res = response.data.data.sunat;
              window.open(res.json.enlace_del_pdf_ticket, "_blank");
            }
          } else {
            color = "danger";
            message = "error";
          }
          // Reseteamos la data
          this.resetFormData();
          this.mtdClose();
          bus.$emit("alert", {
            color: color,
            message: message,
          });
        })
        .catch((errors) => {
          bus.$emit("alert", {
            color: "danger",
            message: errors,
          });
        });
    },
    resetFormData() {
      this.sale = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.value,
        user_id: this.$store.getters.get__user_id,
        existingSportman: true,
        ruc: "",
        document_type_id: "",
        sportsman_id: "",
        date: "",
        type: 0,
        total: "",
        amount: "",
        pending: "",
        entity_document: "",
        entity_name: "",
        entity_address: "",
        bead_id: "",
        booking_id: "",
        sale_id: "",
        new_pending: "",
      };
      this.selectedPayments = [];

      // Reset "Comprobante de Pago" selection
      this.data_comprobante_pago.forEach((item) => {
        item.selected = false;
      });

      // Clear all "Método de Pago" fields
      this.data_metodo_pago.forEach((item) => {
        item.amount = "";
      });
    },
    showSale(sale_id) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/bySale/" +
          sale_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.selectItem(response.data.data.document_type_id);
          this.sale.entity_document =
            response.data.data.voucher[0].voucher_document;
          this.sale.entity_name =
            response.data.data.voucher[0].voucher_fullname;
          this.sale.amount = response.data.data.amount;
          this.sale.pending = response.data.data.pending;
          // this.sale.pending =  response.data.data.pending;
        })
        .catch((errors) => {});
    },
    openTicket(id) {
      window.open(
        this.$store.getters.get__url +
          "/bookings/ticket/" +
          id +
          "/" +
          this.$props.id +
          "/" +
          this.$store.getters.get__user_id,
        "_blank"
      );
    },
    mtdSearchDocument: function () {
      if (this.sale.document_type_id == 1) {
        if (this.sale.entity_document.length == 8) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";

              // this.$refs.SweetAlert.showWarning("DNI no encontrado");
              Swal.fire({
                title: "DNI no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name =
                response.data.name + " " + response.data.last_name;
              this.sale.entity_address = response.data.direccion;
            }
          });
        }
      } else if (this.sale.document_type_id == 2) {
        if (this.sale.entity_document.length == 11) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";
              // this.$refs.SweetAlert.showWarning("RUC no encontrado");
              Swal.fire({
                title: "RUC no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name = response.data.razon_social;
              this.sale.entity_address = response.data.direccion;
            }
          });
        }
      } else if (this.sale.document_type_id == 3) {
        if (this.sale.entity_document.length == 8) {
          this.get({
            url:
              this.$store.getters.get__url +
              "/Consultas/" +
              this.sale.entity_document,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.data.boo == 3) {
              this.sale.entity_document = "";
              this.sale.entity_name = "";
              this.sale.entity_address = "";
              // this.$refs.SweetAlert.showWarning("Dni no encontrado");
              Swal.fire({
                title: "DNI no encontrado",
                icon: "warning",
              });
            } else {
              this.sale.entity_name =
                response.data.name + " " + response.data.last_name;
              this.sale.entity_address = response.data.direccion;
              // this.chkPatiente.address = response.data.direccion;
            }
          });
        }
      }
    },
    validateDNI: function (dni) {
      const dniPattern = /^[0-9]{8}$/;
      return dniPattern.test(dni);
    },
    validateRUC: function () {
      let ruc = event.target.value.replace(/[^0-9.]/g, "");
      this.sale.entity_document = ruc;
    },
    handleKeyUp() {
      if (this.isFactura) {
        this.validateRUC();
      }
    },
    handleEnterKey() {
      if (!this.isFactura) {
        this.filtrarSportMan();
      }
    },
  },
};
</script>
<style scoped>
.bg-purple {
  background-color: #926cdc;
}
.bg-white {
  background-color: white;
}
.bg-gris {
  background-color: #dee2e6;
}
.color-white {
  color: white;
}
.color-black {
  color: black;
}
.font-bold {
  font-weight: bold;
}
.container-type {
  height: 40px;
}
.container-type:hover {
  background-color: #17a2b8; /* bg-info */
  cursor: pointer;
}
.text {
  margin: auto;
}
</style>
